<template>
  <div>
    <br />
        <v-container class="grey lighten-5">
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile>
                <!--MODAL--->
                <div>
                  <button class="add-btn" @click="$bvModal.show('register-modal')"
                    >ADD NEW TICKET</button
                  >
                  <!--LINK TO MODAL - CREATE UNIT PRODUCT - URL: units/unitId/productId-->
                  <b-modal id="register-modal" hide-footer>
                    <template v-slot:modal-title>
                      Add a new ticket
                    </template>
                    <AddTicket />
                  </b-modal>
                </div>
                <!--END OF MODAL-->
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile>
                <div class="prodInfo">
                  <h1>TICKETS</h1>
                  <section v-if="errored">
                    <p>
                      We are sorry, we are not able to retrieve this information
                      at the moment. Please try back later.
                    </p>
                  </section>
                  <section v-else>
                    <div v-if="loading">Loading...</div>
                    <!-- Responsive & Accessible Data Table  -->
                    <div v-else class="container">
                      <table class="responsive-table">
                        <thead>
                          <tr>
                            <th scope="col">Order#</th>
                            <th scope="col">Contact person</th>
                            <th scope="col">email</th>
                            <th scope="col">Comments</th>
                            <th scope="col">Status</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="clientInfo in clientInfo"
                            v-bind:key="clientInfo"
                            class="clientTable"
                          >
                            <th scope="row">
                              {{ clientInfo.sub_package }}
                            </th>
                            <td data-title="Contact person">
                              {{ clientInfo.name }}
                            </td>
                            <td data-title="Email">
                              {{ clientInfo.email_general }}
                            </td>
                            <td data-title="Comments">
                              {{ clientInfo.contact_no}}
                            </td>
                            <td data-title="Status">
                              {{ clientInfo.address }}, {{ clientInfo.postal_code }} {{ clientInfo.city }} 
                            </td>
                            <td>
                              <div class="trashIcon" @click="deleteClient"> <font-awesome-icon class="icon" icon="edit" /></div> <!-- @click="deleteClient" -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
    <!-- <p v-else>
      Loading products
    </p> -->
  </div>
</template>

<script>
import axios from 'axios'
// import ProductService from '@/services/ProductService.js'
import AddTicket from '@/components/ui/AddTicket.vue'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  components: {
    AddTicket
  },
  data() {
    return {
      isLoading: true,
      clientInfo: null,
      loading: true,
      errored: false,
      id: this.client.id  //! sql: "DELETE from clients WHERE id = 'undefined'"
    }
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/clients`)
      .then(response => {
        this.clientInfo = response.data
      })
      // .catch(error => {
      //   console.log(error)
      //   this.errored = true
      // })
      .finally(() => (this.loading = false))  },
  methods: {
    deleteClient() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('client/removeClient', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          // .catch(e => console.log(e))
      }
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.trashIcon {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 30px;
  cursor: pointer;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
.add-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  width: 60%;
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
}

// Breakpoints
$bp-maggie: 15em; 
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

// Styles
// * {
//   @include box-sizing(border-box);
  
//   &:before{
//     @include box-sizing(border-box);
//   }
//   &:after {
//     @include box-sizing(border-box);
//   }
// }

// body {
//   font-family: $helvetica;
//   color: rgba(94,93,82,1);
// }

a {
  color: var(--primary);
  
  &:hover,
  &:focus {
    color: var(--primary); 
  }
}

.container {
  // margin: 5% 3%;
  
  @media (min-width: $bp-bart) {
    // margin: 2%; 
  }
  
  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;
  
  @media (min-width: $bp-bart) {
    font-size: .9em; 
  }
  
  @media (min-width: $bp-marge) {
    font-size: 1em; 
  }
  
  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px; 
    width: 1px; 
    overflow: hidden;
    
    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }
    
    th {
      background-color: var(--bg-light); 
      border: 1px solid var(--bg-light); 
      font-weight: normal;
      text-align: center;
      color: var(--bright); 
      
      &:first-of-type {
        text-align: left; 
      }
    }
  }
  
  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }
  
  tr {   
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row; 
    }
  }
  
  th,
  td {
    padding: .5em;
    vertical-align: middle;
    
    @media (min-width: $bp-lisa) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-cell;
      padding: .5em;
    }
    
    @media (min-width: $bp-marge) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-homer) {
      padding: .75em; 
    }
  }
  
  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
    
    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }
  
  tfoot {
    font-size: .8em;
    font-style: italic;
    
    @media (min-width: $bp-marge) {
      font-size: .9em;
    }
  }
  
  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row-group; 
    }
    
    tr {
      margin-bottom: 1em;
      
      @media (min-width: $bp-bart) {
        // Undo display: block 
        display: table-row;
        border-width: 1px;
      }
      
      &:last-of-type {
        margin-bottom: 0; 
      }
      
      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94,93,82,.1);
        }
      }
    }
    
    th[scope="row"] {
      background-color: var(--bg-light);
      color: white;
      
      @media (min-width: $bp-lisa) {
        border-left: 1px solid  var(--bg-light);
        border-bottom: 1px solid  var(--bg-light);
      }
      
      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94,93,82,1);
        text-align: left;
      }
    }
    
    td {
      text-align: right;
      
      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light); 
        border-bottom: 1px solid  var(--bg-light);
        text-align: center; 
      }
      
      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid  var(--bg-light);
        } 
      }
    }
    
    td[data-type=currency] {
      text-align: right; 
    }
    
    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: .8em;
      color: rgba(94,93,82,.75);
      
      @media (min-width: $bp-lisa) {
        font-size: .9em; 
      }
      
      @media (min-width: $bp-bart) {
        // Don’t show data-title labels 
        content: none; 
      }
    } 
  }
}

  </style>
